import type { ReactNode } from "react";
import { toast as sonnerToast } from "sonner";

type ToastVariant = "default" | "destructive";

type Toast = {
  id?: string | number;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  variant?: ToastVariant;
};

const showToast = ({ title, description, action, variant, id }: Toast) => {
  const message = title ?? "";
  const options = {
    id,
    description,
    action,
  };

  if (variant === "destructive") {
    return sonnerToast.error(message, options);
  }

  return sonnerToast(message, options);
};

function toast(props: Toast) {
  const id = showToast(props);

  return {
    id,
    dismiss: () => sonnerToast.dismiss(id),
    update: (nextProps: Toast) => {
      showToast({ ...nextProps, id });
    },
  };
}

function useToast() {
  return {
    toasts: [] as Toast[],
    toast,
    dismiss: (toastId?: string | number) => sonnerToast.dismiss(toastId),
  };
}

export { useToast, toast };
